import { useSearchParams } from 'react-router-dom'

import { Sheet } from '@/components/ui'

import { AdminGuard } from './AdminGuard'
import { UserDetail } from './UserDetail'
import { UsersList } from './UsersList'

export function AccountsPage() {
  return <AdminGuard><AccountsContent /></AdminGuard>
}

function AccountsContent() {
  const [params, setParams] = useSearchParams()
  const selected = params.get('user')
  const close = () => setParams((current) => {
    const next = new URLSearchParams(current)
    next.delete('user')
    return next
  }, { replace: true })

  return <>
    <UsersList selected={selected} onSelect={(id) => setParams({ user: id })} />
    <Sheet open={selected !== null} onClose={close} title="Редактирование пользователя"
      description="Профиль, доступ и безопасность аккаунта." wide fullMobile>
      {selected ? <UserDetail key={selected} id={selected} /> : null}
    </Sheet>
  </>
}
